package team.platforma.multiplatform_material_extension.ui.buttons.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.ui.input.key.Key
import team.platforma.multiplatform_material_extension.util.KeyGrabber
import team.platforma.multiplatform_material_extension.util.KeyGrabberListener

@Composable
fun initButtonKeyGrabber(keyGrabber: KeyGrabber?, onClickKey: Key?, onClick:() -> Unit) {
    DisposableEffect(keyGrabber) {

        val listener = object : KeyGrabberListener {

            override fun onGrabKey(key: Key) {
                if (onClickKey == key) {
                    onClick()
                }
            }

        }

        keyGrabber?.addListener(listener)

        onDispose {
            keyGrabber?.removeListener(listener)
        }

    }
}